/**
 * 时时彩，通用模板，1分彩，2分彩，5分彩等
 */
import { connect } from 'react-redux'
import { makeBetSubmitConfirmText, makeMmcBetSubmitAlertText, makeMmcBetSubmitAlertButtonText } from '../../../services/lotteryService.jsx'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { DISABLE_LOTTERY_IDS } from '../../../constants/lotterys/config'
import { DOMAIN, MANYCAI_ANALYSE } from '../../../constants/config'
import { LOTTERY_MENUS } from '../../../constants/menus/lotteryMenus'
import * as HistoryCodeRules from '../../../constants/lotterys/rules/recentlyCodesForm/rule-recentCode-entry'
import { sscAlias } from '../../../constants/lotterys/rules/recentlyCodesForm/rule-recentCode-mathch'

import $CACHE from '../../../helpers/cache'

import RichHeader from '../RichHeader.jsx';
import MainFooter from '../../../components/footers/Original_Main.jsx'
import SideBar from '../../../components/affix/SideBar.jsx';

import SscHeader from './SscHeader.jsx';
import BetHistory from './BetHistory.jsx';

import LhcSelectArea from './LhcSelectArea.jsx'
import SscSelectArea from './SscSelectArea.jsx'
import OrderList from './OrderList.jsx';
import TraceBox from './TraceBox.jsx'
import LotteryError from './Error.jsx'
import AddFavorites from './AddFavorites.jsx'

import RecentlyCodes from '../../../components/panel/lottery/RecentlyCodes.jsx'
import RecentlyCodesPlus from '../../../components/panel/lottery/RecentlyCodesPlus.jsx'
import JssmContainer from '../../../components/animation/JssmContainer.jsx'
import Pk10Container from '../../../components/animation/Pk10Container.jsx'
import Popup from '../../../components/modal/popup.jsx'
import DragBox from '../../../components/container/DragBox.jsx'
import {distroyCurrentView} from "../../../actions/reportAction";
import awardSource from '../../../i/pc-day/hy/hy-award-source.png'
import PrizeTj from '../../../i/pc-day/hy/prize-tj.png'
import Proxys from '../../../i/pc-day/hy/proxy.png';
import Proxy2 from '../../../i/pc-day/hy/proxy-2.png'
import Prevents from './Prevents.jsx';

class LotterySsc extends React.Component {

  constructor(props) {
    super(props);
    this.windowId = $.Hex_MD5(_.uniqueId('lotteryWindow') + _.random(10000)).substring(0, 6) + _.uniqueId();
    this.openTrackModal = this.openTrackModal.bind(this);
    this.initMethod = this.initMethod.bind(this);
    this.submitBet = this.submitBet.bind(this);
    this.makeSelectArea = this.makeSelectArea.bind(this);
    this.makeAnimate = this.makeAnimate.bind(this);
    this.updateCurrentLottery = this.updateCurrentLottery.bind(this);
    this.mmcSubmitBet = this.mmcSubmitBet.bind(this);
    this.clearSoloOrder = this.clearSoloOrder.bind(this);
    this.setDragIssue = this.setDragIssue.bind(this);
    this.toggleDisplayAnimation = this.toggleDisplayAnimation.bind(this);
    this.toggleAnimationSize = this.toggleAnimationSize.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.showMenu = this.showMenu.bind(this);
    // 标签睡眠时间
    this.sleepTimter = 0;
    this.state = {
      trackDisplay: false,
      animationDisplay: false,
      dragIssue: '00000000-000',
      sizeMode: {width:540, height:250, className:'default'},
      historyCodes: null,
      hideFavoritePanel: false
    }
    // 拖动窗口按钮 
    this.animationButtons = [
      {
        text: '默认',
        activeKey: 'default',
        action: this.toggleAnimationSize.bind(this, 'default')
      },
      {
        text: '1x',
        activeKey: 'middle',
        action: this.toggleAnimationSize.bind(this, 'middle')
      },
      {
        text: '2x',
        activeKey: 'large',
        action: this.toggleAnimationSize.bind(this, 'large')
      }
    ]
  }

  componentDidMount() {
    // 设置一个当前窗口ID（预留）
    this.props.$$LOTTERY.setWindowId(this.windowId)
    // 初始化
    this.initMethod(this.props);
    // 获取彩种销售信息
    this.props.$$LOTTERY.getLotterySaleInfo();
    // 获取用户最近投注记录
    this.props.$$USER.getUserBetRecent();
    // 睡眠状态下监听彩种销售信息
    this.intervalSleepStatus = window.setInterval(function(){
      if (document.visibilityState == 'visible') {
        // 超过一个小时睡眠，刷新该标签
        if (this.sleepTimter >= 3600) {
          window.location.reload();
          return;
        }
        // 当睡眠时间超过120秒并且已经切换回当前页请求
        if (this.sleepTimter >= 120) {
          this.props.$$LOTTERY.getLotterySaleInfo();
        }
        // 超过10分钟那么请求一次当前奖期
        if (this.sleepTimter >= 600) {
          this.props.$$LOTTERY.getCurrentLotteryIssue(this.props.match.params.lotteryFlag, this.windowId);
        }
        this.sleepTimter = 0;
        return;
      }
      // 睡眠时自增
      this.sleepTimter ++;

    }.bind(this), 1000)
    
    // 获取收藏列表
     this.props.$$COMMON.getFavoritesList();

    $.scroll2Top();
  }

  // 更新彩种信息
  componentWillReceiveProps(nextProps) {
    this.initMethod(nextProps);
  }

  componentWillUnmount() {
    // 清空当前窗口内容
    this.props.$$LOTTERY.clearWindowData(this.windowId)
    if (this.mmcBetTimer) {
      window.clearInterval(this.mmcBetTimer);
    }
    if (this.intervalSleepStatus) {
      window.clearInterval(this.intervalSleepStatus);
      this.intervalSleepStatus = null;
    }
  }

  // 初始化
  initMethod(props) {
    // URL 错误
    if (!_.includes(['ssc', 'lhc', 'animate'], props.match.params.template)) {
      return window.location.href = '#/'
    }

    const __methods = props.__METHOD.toJS();

    // 没有权限
    if (__methods.autheError) {
      window.location.href = '#/';
      window.setTimeout(() => this.props.$$BASE.openAlert(__methods.autheError.message), 1000)
      return
    }

    // 首先判断动态和静态数据是否已经完成加载
    if (!__methods.staticLoadDone || !__methods.dynamicLoadDone) {
      return true;
    }

    if (!window.METHODS.static[props.match.params.lotteryFlag]) {
      return window.location.href = '#/';
    }

    // 临时屏蔽
    if (window.MODEL != 'test' && _.includes(DISABLE_LOTTERY_IDS, Number(window.METHODS.static[props.match.params.lotteryFlag].lotteryId))) {
      return window.location.href = '#/';
    }

    this.updateCurrentLottery(props)

  }

  // 设置
  setHistoryForm(historyCodes){
    if (!historyCodes) {return}
    if (_.isEqual(historyCodes, this.state.historyCodes)) {return}
    this.setState({
      historyCodes: historyCodes
    })
  }

  // 切换玩法
  updateCurrentMethod(method, category){
    const {flag} = category;
    const {desc, menuid, methodid} = method;
    const __window = this.props.__METHOD.toJS().windows[this.windowId];
    // 显示新旧近期开奖
    if (!_.includes(sscAlias, flag)){
      this.setState({
        historyCodes: null
      })
      return;
    }
    HistoryCodeRules.execute({
      desc, menuid, methodid, flag,
      categoryName: category.name,
      methodName: method.originalName || method.name,
      lotteryId: __window.id
    }, __window.history_issue, (result) => this.setHistoryForm(result))
  }

  // 切换彩种，或者第一次加载完成动态区时设置当前玩法
  updateCurrentLottery(props) {

    const __methods = props.__METHOD.toJS();

    // 首先判断动态和静态数据是否已经完成加载
    if (!__methods.staticLoadDone || !__methods.dynamicLoadDone) {
      return;
    }

    // 判断当前区是否和路由中的lotteryFlag一致，如果一致继续
    if (__methods.windows[this.windowId] &&
      __methods.windows[this.windowId].flag == props.match.params.lotteryFlag) {
      return;
    }

    // 默认不显示动画
    this.setState({
      animationDisplay: false
    })
      
    let storeMethods = $CACHE.get('METHOD_MEMORY_' + window.userId);
    storeMethods = storeMethods ? storeMethods.data : [];
    const storeMethod = _.find(storeMethods, {alias: props.match.params.lotteryFlag});
    if (storeMethod) {
      window.location.href = storeMethod.hash;
    }

    this.props.$$LOTTERY.setWindowMethods(props.match.params.lotteryFlag, this.windowId);

  }

  // 切换显示动画
  toggleDisplayAnimation(status){
    this.setState({
      animationDisplay: status
    })
  }

  // 改变动画大小
  toggleAnimationSize(size){
    let sizeMode = {};
    switch(size){
      case 'default': sizeMode = {width:540, height:250, className:'default'}; break;
      case 'middle': sizeMode = {width:810, height:375, className:'middle'}; break;
      case 'large': sizeMode = {width:1080, height:500, className:'large'}; break;
    }
    //setCookie('drag-box-size', JSON.stringify(sizeMode), 30*24*3600);
    this.setState({
      sizeMode: sizeMode
    })
  }

  // 关闭追号窗口
  closeTraceBox() {
    this.setState({
      trackDisplay: false
    })
  }

  // 打开追号窗口
  openTrackModal() {
    const __methods = this.props.__METHOD.toJS();

    // 还没选号
    if (__methods.windows[this.windowId].display.length === 0) {
      return this.props.$$BASE.openAlert('请先选号');
    }

    if (__methods.windows[this.windowId].display.length > 1) {
      return this.props.$$BASE.openConfirm('多注单追号倍率需默认为1倍，已默认设置倍率为1', function () {
        this.setState({
          trackDisplay: true
        })
      }.bind(this))
    }

    this.setState({
      trackDisplay: true
    })
  }
  // 设置动画窗口标题头
  setDragIssue(issue){
    this.setState({
      dragIssue: issue
    })
  }
  // 去投注
  submitBet(withoutConfirm) {
    const __methods = this.props.__METHOD.toJS();
    const __user = this.props.__USER.toJS();
    const betDisplay = __methods.windows[this.windowId].display;
    if (__methods.windows[this.windowId].display.length == 0) { return };
    // 不是一键投注
    if (!withoutConfirm || (_.find(betDisplay, {solo: true}) && __user.info.solo_challenge)) {
      this.props.$$BASE.openConfirm(makeBetSubmitConfirmText(__methods.windows[this.windowId], __user.info.solo_challenge), function () {
        if (this.props.match.params.lotteryFlag == 'mmc') {
          this.mmcSubmitBet();
        } else {
          this.props.$$LOTTERY.submitBet(__methods.windows[this.windowId], this.windowId);
        }
      }.bind(this), null, null, null, _.find(betDisplay, {solo: true}) && __user.info.solo_challenge ? [{text: '清除单挑', action: this.clearSoloOrder}] : null);
      return;
    }
    // 一键投注
    if (this.props.match.params.lotteryFlag == 'mmc') {
      this.mmcSubmitBet();
    } else {
      this.props.$$LOTTERY.submitBet(__methods.windows[this.windowId], this.windowId);
    }

  }
  // 清除单挑注单
  clearSoloOrder(){
    const __methods = this.props.__METHOD.toJS();
    const betDisplay = __methods.windows[this.windowId].display;
    this.props.$$LOTTERY.removeSoloOrder(this.windowId);
    if (betDisplay.length == _.filter(betDisplay, {solo: true}).length) {
      this.props.$$BASE.closeConfirm();
    }else{
      window.setTimeout(() => this.submitBet(), 500)
    }
  }

  // 秒秒彩去投注
  mmcSubmitBet() {
    const __window = this.props.__METHOD.toJS().windows[this.windowId];
    const __times = __window.times;
    this.props.$$LOTTERY.changeMmcBetStatus(this.windowId, true);
    this.mmcBetTimes = 1;
    // 清空上次执行情况
    if (__times > 1) {
      this.props.$$BASE.openAlert(makeMmcBetSubmitAlertText(__window, this.mmcBetTimes), this.props.$$LOTTERY.changeMmcBetStatus, 0, '连续游戏', makeMmcBetSubmitAlertButtonText(__window, this.mmcBetTimes), this.windowId);
    }
    // 延时执行
    const delayTime = __times == 1 ? 500 : 2000
    // 第一次投注
    this.props.$$LOTTERY.mmcSubmitBet(__window, this.windowId, 1);
    this.mmcBetTimer = window.setInterval(function () {
      const __window = this.props.__METHOD.toJS().windows[this.windowId];
      const __times = __window.times;
      // 如果 上一次的投注数据还没有回来
      if (__window.excute.length < this.mmcBetTimes) {
        return;
      }
      this.mmcBetTimes++;
      this.props.$$BASE.openAlert(makeMmcBetSubmitAlertText(__window, this.mmcBetTimes), this.props.$$LOTTERY.changeMmcBetStatus, 0, __times == 1 ? '提示' : '连续游戏', makeMmcBetSubmitAlertButtonText(__window, this.mmcBetTimes), this.windowId)
      // 投注完成
      if (this.mmcBetTimes > __times || !__window.beting) {
        window.clearInterval(this.mmcBetTimer);
        this.props.$$LOTTERY.clearMmcExcute(this.windowId);
        return;
      }
      // 去投注
      this.props.$$LOTTERY.mmcSubmitBet(__window, this.windowId, this.mmcBetTimes);

    }.bind(this), delayTime)
  }

  // 生成选号区
  makeSelectArea() {
    switch (this.props.match.params.template) {
      case 'ssc':
      case 'animate': return <SscSelectArea params={this.props.match.params} windowId={this.windowId} submit={this.submitBet} openTrack={this.openTrackModal} updateCurrentMethod={this.updateCurrentMethod.bind(this)} />; break;
      case 'lhc': return <LhcSelectArea params={this.props.match.params} windowId={this.windowId} submit={this.submitBet} openTrack={this.openTrackModal}  updateCurrentMethod={this.updateCurrentMethod.bind(this)}/>; break;
    }
  }
  
  // 生成动画
  makeAnimate() {
    const { lotteryFlag } = this.props.match.params;
    const animateMap = {
      jssm: <JssmContainer windowId={this.windowId} alias={lotteryFlag} setIssue={this.setDragIssue}  sizeMode={this.state.sizeMode} />,
      pk10: <Pk10Container windowId={this.windowId} alias={lotteryFlag} setIssue={this.setDragIssue}  sizeMode={this.state.sizeMode} />,
      ydl10:<Pk10Container windowId={this.windowId} alias={lotteryFlag} setIssue={this.setDragIssue}  sizeMode={this.state.sizeMode} />,
      xyft:<Pk10Container windowId={this.windowId} alias={lotteryFlag} setIssue={this.setDragIssue}  sizeMode={this.state.sizeMode} />
    }
    return animateMap[lotteryFlag];
  }
  //用于判断显示收藏按钮时视频按钮的位置
  hideMenu(){
    this.setState({
      hideFavoritePanel: true
    });
  }
  //用于判断显示收藏按钮时视频按钮的位置
  showMenu(){
    this.setState({
      hideFavoritePanel: false
    });
  }

  render() {
    let trackPre, currentMethod;
    const {historyCodes} = this.state;
    if(historyCodes){
        currentMethod = historyCodes.currentMethod;
        trackPre = currentMethod.flag == 'mmc' ? 'mmc/' : '';
    }
    const __base = this.props.__BASE.toJS();
    const __common = this.props.__COMMON.toJS();
    const __methods = this.props.__METHOD.toJS();
    let __window = "",lotteryId = "";
    if(__methods.windows[this.windowId]){
      __window = __methods.windows[this.windowId];
      lotteryId = __window.id;
    }
    return (
      <div className="lottery-bg">
        {
          !__window ? null :
            <div>
              <div className='lottery-ssc-framework'>
                <RichHeader className="sscRichHeader" />
                <SideBar />
                <div className='lottery_main_bg'>
                    <div className="lottery-main">
                        {
                            __window.error ?
                                <div className='container-main'>
                                    {/*<SscHeader params={this.props.match.params} windowId={this.windowId} />*/}
                                    <LotteryError text={__window.error} params={this.props.match.params} />
                                </div> :
                                <div className='container-main'>
                                    <div className="nbfc_z">
                                        <div className="left-box">

                                            <SscHeader params={this.props.match.params} windowId={this.windowId} />
                                            <div className='lotteryRight fl'>
                                                <div className='fullHeight'>
                                                    {
                                                        this.state.historyCodes ?
                                                            <RecentlyCodesPlus historyCodes={this.state.historyCodes}/>
                                                            :
                                                            <RecentlyCodes
                                                                history={__window.history_issue}
                                                                tmpl={this.props.match.params.template}
                                                                current={__methods.windows[this.windowId].current_issue}
                                                                flag={__methods.windows[this.windowId].flag}
                                                                lotteryId={__window!=""?lotteryId:''}
                                                                windowId={this.windowId}
                                                                __methods = {__methods}
                                                            />
                                                    }
                                                </div>
                                            </div>
                                            <BetHistory />
                                        </div>
                                        <div className="right-box">
                                            <div className={"lottery-selectarea-main inline-block lottery-main-" + this.props.match.params.lotteryFlag} >
                                                <ReactCSSTransitionGroup
                                                    transitionAppear={window.isIE?false:true}
                                                    transitionEnter={window.isIE?false:true}
                                                    transitionLeave={window.isIE?false:true}
                                                    transitionEnterTimeout={300}
                                                    transitionLeaveTimeout={300}
                                                    transitionAppearTimeout={300}
                                                    transitionName='slide'>
                                                    <div key={this.props.match.params.lotteryFlag} className="cf re">
                                                        {
                                                            this.makeSelectArea()
                                                        }

                                                    </div>
                                                </ReactCSSTransitionGroup>
                                            </div>
                                            <OrderList
                                                windowId={this.windowId}
                                                openTrack={this.openTrackModal}
                                                submit={this.submitBet}
                                                params={this.props.match.params}
                                            />
                                            {
                                                this.state.trackDisplay ?
                                                    <TraceBox
                                                        windowId={this.windowId}
                                                        closeFn={this.closeTraceBox.bind(this)}
                                                        display={true}
                                                        submit={this.submitBet}
                                                    /> : null
                                            }
                                        </div>
                                    </div>
                                    {
                                        currentMethod ?
                                            <a className='trend_chart' target="_blank" href={DOMAIN + trackPre + 'game/bonuscode?lotteryid='+ currentMethod.lotteryId +'&issuecount=30'}></a>
                                            :
                                            this.props.match.params.template != 'lhc'?
                                              <a className='trend_chart' target="_blank"
                                                 href={
                                                     __methods.windows[this.windowId].flag=="mmc"?
                                                     DOMAIN + 'mmc/game/bonuscode?lotteryid='+(__window!=""?lotteryId:'')+'&issuecount=30'
                                                     :
                                                     DOMAIN + 'game/bonuscode?lotteryid='+(__window!=""?lotteryId:'')+'&issuecount=30'
                                                 }>
                                              </a>
                                              :
                                              null
                                    }
                                   
                                    {
                                        this.props.match.params.template== 'animate' ?
                                            <p className={this.state.hideFavoritePanel ? "openAnimation hideFavorite" :"openAnimation"} onClick={this.toggleDisplayAnimation.bind(this,true)}></p>
                                            :null
                                    }
                                    {
                                      MANYCAI_ANALYSE[__window.flag] &&
                                      <a className="manycai-analyse" target="_blank" href={`https://manycaia1.net/?hmsr=hengcai&hmpl=%E6%81%86%E5%BD%A9&hmcu=&hmkw=&hmci=#/lotteryChart/detail?${MANYCAI_ANALYSE[__window.flag]}`} />
                                    }
                                </div>
                        }
                        {                          
                            <AddFavorites alias={__window.flag} hideMenu={this.hideMenu} showMenu={this.showMenu} />
                        }
                    </div>
                </div>

                <MainFooter />
              </div>
            </div>
        }
        {
          this.props.match.params.template== 'animate' ?
          <DragBox
            display={this.state.animationDisplay}
            onClose={this.toggleDisplayAnimation}
            text={'视频开奖 - 第 ' + this.state.dragIssue + ' 期'}
            subTitle='视频大小：'
            buttons={this.animationButtons}
            sizeMode={this.state.sizeMode}
            onCloseSize={this.toggleAnimationSize}
          >
            {
              this.makeAnimate()
            }
          </DragBox>
          :null
        }
        <Prevents lotteryId={__window.id} alias={__window.flag} />
      </div>
    );
  }
}

reactMixin(LotterySsc.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __LOTTERY: state.lottery,
    __METHOD: state.method,
    __COMMON: state.common,
    __USER:state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LotterySsc)